import debounce from 'lodash/debounce';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import {ProductPriceData} from '@/components/containers/pdp/utils/product-price-data';
import {ConsumerProductPriceData} from '@/components/containers/pdp/utils/consumer-product-price-data';
import {isBuildToOrderByCode} from '@/components/containers/pdp/utils/retailers-helper';
import {mapGetters} from 'vuex';

const ProductDetails = {
  props: {
    product: {
      type: Object,
      required: true,
    },
    options: {
      type: Object,
      required: true,
    },
    copyPositioningStatement: {
      type: String,
      default: '',
      required: false,
    },
  },

  watch: {
    variantCode(value) {
      if (!this.showLocallyWidget && !this.options.isLocallyActive) {
        this.$emit('loadRpaResults', value);
      }
    },
  },

  computed: {
    ...mapGetters('backend', ['b2b', 'consumerFriendlyMode']),

    variant() {
      if (!this.variantCode) {
        return {};
      }

      const variant = this.product.variants.find((variant) => variant.code === this.variantCode);
      return !variant ? {} : variant;
    },

    isPurchasable() {
      return (
        get(this.variant, 'isPurchasable', false) && !isBuildToOrderByCode(get(this.stockData, 'globalStockStatus'))
      );
    },

    isBike() {
      return get(this.product, 'productType') === 'bike';
    },

    projectOneUrl() {
      return get(this.product, 'projectOneUrl', '');
    },

    hasImages() {
      return this.product.images && Object.keys(this.product.images).length > 0;
    },

    hasPrice() {
      if (!this.pricingData || !this.pricingData.retailerPrice) {
        return false;
      }

      const price = get(
        this.pricingData,
        'retailerPrice.price.formatted',
        get(this.pricingData, 'retailerPrice.price.low.formatted')
      );
      return !isEmpty(price);
    },

    consumerPrice() {
      let pricingData = get(this.pricingData, 'consumerPrice') || get(this.product, 'consumerPrice');
      if (!pricingData && this.consumerFriendlyMode) {
        return new ConsumerProductPriceData(this.populatePriceData(pricingData, []), {
          b2b: this.b2b,
        });
      }
      if (!pricingData || !Object.keys(pricingData).length) {
        return this.retailerPrice;
      }

      return new ConsumerProductPriceData(this.populatePriceData(pricingData, ['apple'], 'retailerPrice'), {
        b2b: this.b2b,
      });
    },

    retailerPrice() {
      let pricingData = get(this.pricingData, 'retailerPrice', {});
      if (!pricingData || !Object.keys(pricingData).length) {
        pricingData = get(this.product, 'retailerPrice', {});
      }

      return new ProductPriceData(
        this.populatePriceData(pricingData, ['advertised', 'saleAdvertised'], 'consumerPrice'),
        {b2b: this.b2b}
      );
    },
  },

  methods: {
    populatePriceData(target, keys, from) {
      if (!target) {
        target = {};
      }

      const priceData = !this.pricingData || !Object.keys(this.pricingData).length ? this.product : this.pricingData;
      keys.forEach((key) => {
        const itemData = get(priceData, `${from}.${key}`);
        if (itemData) {
          target[key] = itemData;
        }
      });

      return target;
    },

    updateshowLocallyWidget(state) {
      this.showLocallyWidget = state;
      this.$emit('loadRpaResults', this.variantCode);
    },

    loadPricing: debounce(function(productCode) {
      if (!productCode) {
        this.pricingData = {};
      } else {
        const pricing = this.product.variants.find((variant) => variant.code === productCode);
        if (pricing) {
          this.pricingData = {
            retailerPrice: get(pricing, 'retailerPrice'),
            consumerPrice: get(pricing, 'consumerPrice'),
          };
        }
      }
    }, 10),
  },

  data() {
    return {
      selectedColor: '',
      variantCode: '',
      pricingData: null,
      showLocallyWidget: this.options.isLocallyActive,
    };
  },
};

export {ProductDetails};
